/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type IssueTypesDirectory from '@jira/spa-apps__admin-pages-issue-types-issue-types-directory/src/IssueTypesDirectoryWithErrorBoundary.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyIssueTypesDirectory: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<any, any>) => React.JSX.Element
> = lazyForPaint<typeof IssueTypesDirectory>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-issue-types-directory", jiraSpaEntry: "async-admin-pages-issue-types-directory" */ '@jira/spa-apps__admin-pages-issue-types-issue-types-directory/src/IssueTypesDirectoryWithErrorBoundary.tsx'
		),
	),
);

const AsyncIssueTypesDirectory = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIssueTypesDirectory}
		pageId="jira-admin-pages-issue-types-directory"
		shouldShowSpinner
	/>
);

export default AsyncIssueTypesDirectory;
